export enum DayEnum {
    LUNDI = "Lundi",
    MARDI = "Mardi",
    MERCREDI = "Mercredi",
    JEUDI = "Jeudi",
    VENDREDI = "Vendredi",
    SAMEDI = "Samedi",
    DIMANCHE = "Dimanche",
}
